import React, { useEffect } from "react";
import { PromoBar } from "./components/PromoBar";
import { Hero } from "./components/Hero";
import { PainSection } from "./components/PainSection";
import { ProductIntro } from "./components/ProductIntro";
import { BookContents } from "./components/BookContents";
import { Bonuses } from "./components/Bonuses";
import { WhatYouGet } from "./components/WhatYouGet";
import { Pricing } from "./components/Pricing";
import { Testimonials } from "./components/Testimonials";
import { Guarantee } from "./components/Guarantee";
import { Faq } from "./components/Faq";
import { BeforeAfter } from "./components/BeforeAfter";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
import { MobileCtaBar } from "./components/MobileCtaBar";
import { initPixel } from "./utils/pixel";
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div lang="fr" className="min-h-screen w-full overflow-x-hidden bg-ink pb-20 font-sans text-cream antialiased md:pb-0" data-id="element-0" data-mp="23u9vyt7xrnzx">
      <PromoBar data-id="element-1" data-mp="3ijpc2xoqyt86" />
      <main data-id="element-2" data-mp="3ii4sg33z0up3">
        <Hero data-id="element-3" data-mp="3mlj8uuvtnd32" />
        <PainSection data-id="element-4" data-mp="3ml1397n9rmih" />
        <ProductIntro data-id="element-5" data-mp="3mkhou0wtvg97" />
        <BookContents data-id="element-6" data-mp="3mjq2lgp4euvl" />
        <Bonuses data-id="element-7" data-mp="3mj6lg27aoaim" />
        <WhatYouGet data-id="element-8" data-mp="3rcj31sdk3h1v" />
        <Pricing data-id="element-9" data-mp="3rdaquh0wwahl" />
        <Testimonials data-id="element-10" data-mp="3rcsy3udgkeef" />
        <Guarantee data-id="element-11" data-mp="3reccfffk0fdk" />
        <Faq data-id="element-12" data-mp="5yh2n2cyzbp" />
        <BeforeAfter data-id="element-13" data-mp="6hp9c27i9cj" />
        <FinalCta data-id="element-14" data-mp="4wyzymxdckh" />
      </main>
      <Footer data-id="element-15" data-mp="82ld64660ci" />
      <MobileCtaBar data-id="element-16" data-mp="7sxbo2oq39g" />
    </div>;
}